import {Card} from 'platform/components';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {DmsDataGrid, Section, WAREHOUSE_GRID_CODES} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

interface UpdateResultsProps extends RequiredTestIdProps {
  articleUpdateJobId: string;
}

export function UpdateResults(props: UpdateResultsProps) {
  const queryModifier = useCallback(
    (filter: QueryFilterObject) =>
      mergeAll([filter, {articleUpdateJobId: props.articleUpdateJobId}]),
    [props.articleUpdateJobId]
  );
  return (
    <Section isFullHeight>
      <Card
        isFullHeight
        hasSeparator
        title={i18n.t('page.warehouse.labels.updateResults')}
        actions={[
          {
            type: 'button',
            variant: 'link',
            title: i18n.t('general.actions.refresh'),
            leftIcon: 'content/add_circle',
            isDisabled: true,
          },
        ]}
      >
        <DmsDataGrid
          gridCode={WAREHOUSE_GRID_CODES.articleUpdateJobLog}
          queryModifier={queryModifier}
          data-testid={WAREHOUSE_GRID_CODES.articleUpdateJobLog}
        />
      </Card>
    </Section>
  );
}
